export default function About() {
  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Image */}
          <div className="order-2 md:order-1">
            <div
              className="aspect-[4/5] rounded-sm overflow-hidden"
              style={{ backgroundColor: 'var(--color-cream)' }}
            >
              <img
                src="/images/Madison-headshot.jpeg"
                alt="Madi Alvarez - Yoga Teacher and Mindfulness Guide"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <p
              className="text-sm font-medium tracking-[0.2em] uppercase mb-4"
              style={{ color: 'var(--color-gold)' }}
            >
              About
            </p>

            <h2
              className="font-heading text-4xl md:text-5xl mb-6"
              style={{ color: 'var(--color-dark)' }}
            >
              Meet Madi
            </h2>

            <div className="space-y-4">
              <p
                className="text-base md:text-lg leading-relaxed"
                style={{ color: 'var(--color-dark-light)' }}
              >
                Madi is a yoga teacher and mindfulness guide based in West Los
                Angeles. Her work centers joy, play, and connection as pathways
                to healing and self-trust.
              </p>

              <p
                className="text-base md:text-lg leading-relaxed"
                style={{ color: 'var(--color-dark-light)' }}
              >
                Drawing from embodied awareness, intuitive movement, and
                somatic-informed practices, Madi creates spaces where people feel
                seen, grounded, and free to explore their inner worlds with
                curiosity and care. She also loves weaving in the wisdom of
                nature...inviting us to slow down, tune into natural rhythms, and
                remember that we, too, are allowed seasons, cycles, and growth.
              </p>

              <p
                className="text-base md:text-lg leading-relaxed"
                style={{ color: 'var(--color-dark-light)' }}
              >
                Madi believes our greatest strength comes from returning to the
                body, honoring authenticity, and knowing that healing can be
                gentle, creative, and deeply human.
              </p>
            </div>

            {/* Signature or additional element */}
            <div className="mt-8 pt-8" style={{ borderTop: '1px solid var(--color-cream)' }}>
              <p
                className="font-heading text-xl italic"
                style={{ color: 'var(--color-olive)' }}
              >
                "Breathe deeply, move mindfully, live fully."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
